<div class="session-limits-expired-alert-container-v2">
	<div class="header">
		<img obgImageContent="responsible-gaming.time-out" obgImageContentGroup="common" />
		<h1
			class="header-text"
			[innerHTML]="'user-summary.session-limit-expired-next-time-login-title' | translate"
		></h1>
	</div>

	<div class="content" *ngIf="dailySessionLimitHours !== undefined">
		<p
			[innerHTML]="'user-summary.desktop-session-limit-expired-next-time-login-message' | translate: {
			dailySessionLimitInHours: dailySessionLimitHours,
			nextTimeLogin: nextTimeLogin
		}"
		></p>
	</div>
</div>
